import { render, staticRenderFns } from "./proxyRoleList.vue?vue&type=template&id=4ec54dd6"
import script from "./proxyRoleList.vue?vue&type=script&lang=js"
export * from "./proxyRoleList.vue?vue&type=script&lang=js"
import style0 from "./proxyRoleList.vue?vue&type=style&index=0&id=4ec54dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports